var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 15,
    viewBox: "0 0 3 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 13.125C2.625 13.3846 2.54802 13.6383 2.4038 13.8542C2.25959 14.07 2.0546 14.2383 1.81477 14.3376C1.57495 14.4369 1.31104 14.4629 1.05644 14.4123C0.801845 14.3616 0.56798 14.2366 0.384423 14.0531C0.200867 13.8695 0.075863 13.6357 0.0252199 13.3811C-0.0254232 13.1265 0.000568681 12.8626 0.0999087 12.6227C0.199249 12.3829 0.367475 12.1779 0.583315 12.0337C0.799154 11.8895 1.05291 11.8125 1.3125 11.8125C1.6606 11.8125 1.99444 11.9508 2.24058 12.1969C2.48672 12.4431 2.625 12.7769 2.625 13.125ZM1.3125 9.84375C1.48655 9.84375 1.65347 9.77461 1.77654 9.65154C1.89961 9.52847 1.96875 9.36155 1.96875 9.1875V0.65625C1.96875 0.482202 1.89961 0.315282 1.77654 0.192211C1.65347 0.0691406 1.48655 0 1.3125 0C1.13845 0 0.971533 0.0691406 0.848462 0.192211C0.725391 0.315282 0.656251 0.482202 0.656251 0.65625V9.1875C0.656251 9.36155 0.725391 9.52847 0.848462 9.65154C0.971533 9.77461 1.13845 9.84375 1.3125 9.84375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.c0e97957cce139092b13a814d40a4e3b.svg";
export { ForwardRef as ReactComponent };